import { render, staticRenderFns } from "./list.vue?vue&type=template&id=603ae0c8&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=603ae0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ae0c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('603ae0c8')) {
      api.createRecord('603ae0c8', component.options)
    } else {
      api.reload('603ae0c8', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=603ae0c8&scoped=true&", function () {
      api.rerender('603ae0c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/list.vue"
export default component.exports